import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wachbuch',
  templateUrl: './wachbuch.component.html',
  styleUrls: ['./wachbuch.component.css']
})
export class WachbuchComponent implements OnInit {

  showTableStatus;
  showFormStatus;
  formEntryId;

  constructor() {
    this.showTableStatus=true;
    this.showFormStatus=false;
  }

  ngOnInit() {
  }

  editEntry(key) {
    this.formEntryId = key;
    this.showTableStatus=false;
    this.showFormStatus=true;
  }
  showTable(){
    this.formEntryId = '';
    this.showTableStatus=true;
    this.showFormStatus=false;
  }

}
